// extracted by mini-css-extract-plugin
export default {"Text":"ChecksStatusBadgeHeader-module__Text--IBN_O","Text_1":"ChecksStatusBadgeHeader-module__Text_1--nuXs5","Text_2":"ChecksStatusBadgeHeader-module__Text_2--nXTHk"};